'use client'

import { Header as HeaderComponent } from 'design-system/client'
import { useTranslations , useLocale } from 'next-intl'
import type { LinkItemData } from 'node_modules/design-system/src/lib/pageParts/shared/types'
import { type ReactNode, useMemo } from 'react'
import TextLink from '@/components/TextLink'
import { RailsRoutes } from '@/helpers/utils'

function Header({ children }: { children: ReactNode }) {
  const locale = useLocale()
  const t = useTranslations('nextjs.header')
  const searchUrl = RailsRoutes.homePageSearch({ locale })
  const links = useMemo(
    (): Array<LinkItemData> => [
      { children: t('links.discover'), href: RailsRoutes.discovery({ locale }), prefetch: false },
      { children: t('links.collect'), href: RailsRoutes.collect({ locale }), prefetch: false },
      { children: t('links.aboutUs'), href: RailsRoutes.aboutUs({ locale }), prefetch: false },
    ],
    [locale, t]
  )
  return (
    <HeaderComponent
      text={{
        logoAlt: t('betterplace_logo_alt_text'),
        claim: t('claim'),
        homePageUrl: process.env.NEXT_PUBLIC_BETTERPLACE_URL,
        searchUrl,
        searchLabel: t('search.placeholder'),
        searchPlaceholder: t('search.placeholder'),
        links,
      }}
      Link={TextLink}
    >
      {children}
    </HeaderComponent>
  )
}

export default Header
